// Step 1 of the WYSIWYG paragraph editing pipeline.
// Applied symmetrically to the resolved-before string and the
// contenteditable's textContent before diffing.
//
// The order is load-bearing: NFC -> strip -> whitespace -> trim.
// Determinism is the safety property; pinning the order prevents
// silent output drift on edge-case inputs.
//
// See docs/superpowers/specs/2026-05-29-wysiwyg-paragraph-editing-design.md
// Step 1 for the full rationale.

// Code points to strip:
// - U+200E LRM, U+200F RLM
// - U+202A-E deprecated bidi formatting (LRE/RLE/PDF/LRO/RLO)
// - U+2066-9 bidi isolates (LRI/RLI/FSI/PDI)
// - U+FEFF ZWNBSP / BOM
// - U+200B ZWSP
//
// Explicitly preserved (script-meaningful, never strip):
// - U+200C ZWNJ, U+200D ZWJ
const STRIP_CHARS_REGEX = /[‎‏‪-‮⁦-⁩﻿​]/g;

export function canonicalize(input: string): string {
  // 1. NFC: canonicalize codepoint sequence
  let s = input.normalize("NFC");
  // 2. Strip bidi formatting + zero-width formatting (NOT ZWJ/ZWNJ)
  s = s.replace(STRIP_CHARS_REGEX, "");
  // 3. Whitespace canonicalization
  s = s.replace(/\r\n/g, "\n");      // CRLF -> LF
  s = s.replace(/[\n\t]/g, " ");     // LF, tab -> space
  s = s.replace(/[ ]{2,}/g, " ");    // multi-space -> single space (after CR/LF/tab become spaces)
  s = s.replace(/[ \t\n]+/g, " ");   // any remaining mixed runs -> single space (defensive)
  // 4. Trim leading/trailing whitespace
  s = s.trim();
  return s;
}
